export const getNotificationImgPathes = (eventType: string) => ({
    'Group': `/${eventType}/${eventType}-Group.png`,
    'Public': `/${eventType}/${eventType}-Public.png`,
    'Default': `/${eventType}/${eventType}-Default.png`,
})